/**
 * Fetch helper avec JWT + baseUrl backoffice.
 */
import api from '../../config/api.config';

export interface AgentRecouvrement {
  id: number;
  nom: string;
  prenoms: string;
  nom_complet: string;
  telephone: string;
  device_id: string;
  device_id_short: string;
  date_enregistrement: string;
  dernier_ping: string | null;
  ip_derniere: string;
  user_agent_dernier: string;
  actif: boolean;
  nb_verifications: number;
  nb_sessions_actives: number;
  date_desactivation: string | null;
  desactive_par: string;
  motif_desactivation: string;
}

export interface VerifRecord {
  id: number;
  agent_id: number;
  agent_nom: string;
  matricule: string;
  etudiant_nom: string;
  etudiant_classe: string;
  methode: string;
  methode_libelle: string;
  date: string;
  ip: string;
  etait_a_jour: boolean | null;
  solde: string | null;
  mode_acces: string;
}

export async function listAgents(): Promise<{ results: AgentRecouvrement[]; count: number }> {
  const r = await api.get('/admin/recouvrement/agents/');
  return r.data;
}

export async function toggleAgent(id: number, actif: boolean, motif?: string): Promise<void> {
  await api.post(`/admin/recouvrement/agents/${id}/toggle/`, { actif, motif });
}

export async function deleteAgent(id: number): Promise<void> {
  await api.delete(`/admin/recouvrement/agents/${id}/`);
}

export interface FusionResult {
  ok: boolean;
  total_supprimes: number;
  fusions: Array<{
    conserve: { id: number; nom_complet: string };
    absorbes: Array<{ id: number; device_id: string }>;
    nb_verifs_deplacees: number;
  }>;
}

export async function fusionnerDoublons(): Promise<FusionResult> {
  const r = await api.post('/admin/recouvrement/agents/fusionner-doublons/');
  return r.data;
}

export async function listVerifications(params: {
  agent?: number;
  matricule?: string;
  depuis?: string;
  jusqu?: string;
  limit?: number;
} = {}): Promise<{ results: VerifRecord[]; count: number; total: number; stats: any }> {
  const r = await api.get('/admin/recouvrement/verifications/', { params });
  return r.data;
}

export async function getCodeAcces(): Promise<{ code: string }> {
  const r = await api.get('/admin/recouvrement/code-acces/');
  return r.data;
}

export async function setCodeAcces(code: string): Promise<any> {
  const r = await api.post('/admin/recouvrement/code-acces/set/', { code });
  return r.data;
}

export interface StatsJournalier {
  periode_jours: number;
  total_periode: number;
  par_jour: Array<{ date: string; total: number }>;
  detail_jour_agent: Array<{
    date: string; agent_id: number; agent_nom: string; total: number;
  }>;
  top_agents: Array<{ agent_id: number; nom_complet: string; total: number }>;
}

export async function getStatsJournalier(jours: number = 30, agent?: number): Promise<StatsJournalier> {
  const r = await api.get('/admin/recouvrement/stats-journalier/', {
    params: { jours, ...(agent ? { agent } : {}) },
  });
  return r.data;
}
